"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.flushEvents = exports.record = void 0;
var apis_1 = require("./apis");
Object.defineProperty(exports, "record", { enumerable: true, get: function () { return apis_1.record; } });
Object.defineProperty(exports, "flushEvents", { enumerable: true, get: function () { return apis_1.flushEvents; } });
